import React, { Component } from "react";
import SimplifiedLayout from "../SimplifiedLayout";
import { Grid, Col, Row } from "react-bootstrap";
import Helmet from "react-helmet";

class PendingAccountPage extends Component {
    render() {
        return (
            <div>
            	<Helmet title="Access Requested"/>
                <SimplifiedLayout>
                    <Grid className="text-center">
                        <Row>
                            <Col sm={12}>
                                <h1>
                                    <i
                                        className="fa fa-envelope-open-o fa-3x"
                                        aria-hidden="true"
                                    />
                                </h1>
                                <h2>Nearly there</h2>
                                <h4>
                                    Check your email and click the link to finish signing up!                                    
                                </h4>
                            </Col>
                        </Row>

                    </Grid>
                </SimplifiedLayout>
            </div>
        );
    }
}

export default PendingAccountPage;



// WEBPACK FOOTER //
// ./src/signup/PendingAccountPage.js